import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const highlights1 = [
    "Golf Course Facing 2, 3 & 4 BHK Residences",
    "Premium Location in Chembur, A prime residential hub",
    "Seamless Connectivity to Eastern Freeway, Monorail & Metro",
  ];
  const highlights2 = [
    "All Standard Amenities including Clubhouse, Gym & More",
    "Spacious Homes with Premium Finishes for luxurious living",
    "G+30 High-Rise Development with Modern architectural design",
  ];
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      {/* <div class="theme-element timer-element">
        <picture>
          <img
            src="../images/timer-left-element.svg"
            width="100%"
            alt="House of Hiranandani Chembur"
          />
        </picture>
      </div> */}
      {/* <div class="theme-element timer-element-right">
        <picture>
          <img
            src="../images/timer-right-element.svg"
            width="100%"
            alt="House of Hiranandani Chembur"
          />
        </picture>
      </div> */}
      <div class="over1">
        <h1
          class="d-block section-heading color-primary text-capitalize"
          style={{ marginBottom: "1.25rem" }}
        >
          {project} - Project Overview
        </h1>
        <p>
          Hiranandani Chembur is a luxury residential development in the heart
          of Chembur, offering breathtaking golf course views, spacious layouts,
          and premium amenities. This G+30 storey high-rise is designed for
          sophisticated living, ensuring maximum comfort, elegance, and
          connectivity. With world-class lifestyle amenities and an exclusive
          community, Hiranandani Chembur is set to become one of Mumbai’s most
          prestigious addresses.
          {/* <strong>
            Pre-Launch Booking Open – Secure Your Dream Home Today!
          </strong> */}
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          Highlights of {project}
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
